(() => {
  const shopLinkSelector = ".header-menu .menu-list__link[href*='/collections/all']";
  const menuItemSelector = ".header-menu .menu-list__list-item";
  const directPanelClass = 'rovynel-shop-direct-dropdown';

  const normalizeText = (text) => (text || '').replace(/\s+/g, ' ').trim();

  const getHeaderMenu = (header) => header?.querySelector('header-menu');

  const resetNativeHeaderState = (header) => {
    if (!header) return;
    const headerMenu = getHeaderMenu(header);
    header.style.setProperty('--submenu-height', '0px');
    header.style.setProperty('--full-open-header-height', '0px');
    if (headerMenu) {
      headerMenu.style.setProperty('--submenu-opacity', '0');
      headerMenu.dataset.overflowExpanded = 'false';
      headerMenu.setAttribute('aria-expanded', 'false');
    }
  };

  const collectShopLinks = (nativeSubmenu) => {
    const seen = new Set();
    const links = [];
    nativeSubmenu?.querySelectorAll('a.mega-menu__link').forEach((anchor) => {
      const title = normalizeText(anchor.textContent);
      const href = anchor.getAttribute('href');
      if (!title || !href) return;
      const key = `${href}|${title}`;
      if (seen.has(key)) return;
      seen.add(key);
      links.push({ title, href });
    });
    return links;
  };

  const buildDirectPanel = (item, links) => {
    let panel = item.querySelector(`.${directPanelClass}`);
    if (!panel) {
      panel = document.createElement('div');
      panel.className = directPanelClass;
      panel.setAttribute('role', 'menu');
      panel.setAttribute('aria-label', 'Shop');
      item.append(panel);
    }

    const list = document.createElement('ul');
    list.className = 'rovynel-shop-direct-dropdown__list';
    links.forEach(({ title, href }) => {
      const li = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.className = 'rovynel-shop-direct-dropdown__link';
      anchor.href = href;
      anchor.setAttribute('role', 'menuitem');
      anchor.textContent = title;
      li.append(anchor);
      list.append(li);
    });

    panel.replaceChildren(list);
    return panel;
  };

  const closeDirectPanel = (header) => {
    if (!header) return;
    const item = header.querySelector('[data-rovynel-direct-shop-ready]');
    const link = item?.querySelector(shopLinkSelector);
    const panel = item?.querySelector(`.${directPanelClass}`);

    delete header.dataset.rovynelShopDirectOpen;
    if (item) delete item.dataset.rovynelShopDirectOpen;
    if (panel) panel.hidden = true;
    if (link) link.setAttribute('aria-expanded', 'false');

    resetNativeHeaderState(header);
  };

  const openDirectPanel = (item) => {
    const header = item.closest('header-component');
    const link = item.querySelector(shopLinkSelector);
    const panel = item.querySelector(`.${directPanelClass}`);
    if (!header || !link || !panel) return;

    header.dataset.rovynelShopDirectOpen = 'true';
    item.dataset.rovynelShopDirectOpen = 'true';
    panel.hidden = false;

    requestAnimationFrame(() => {
      link.setAttribute('aria-expanded', 'false');
      resetNativeHeaderState(header);
    });
    setTimeout(() => {
      link.setAttribute('aria-expanded', 'false');
      resetNativeHeaderState(header);
    }, 60);
  };

  const prepareShopItem = (item) => {
    if (!item || item.dataset.rovynelDirectShopReady === 'true') return;

    const link = item.querySelector(shopLinkSelector);
    const nativeSubmenu = item.querySelector('[ref="submenu[]"]');
    if (!link || !nativeSubmenu) return;

    const links = collectShopLinks(nativeSubmenu);
    if (!links.length) return;

    buildDirectPanel(item, links).hidden = true;

    nativeSubmenu.removeAttribute('ref');
    nativeSubmenu.setAttribute('hidden', '');
    nativeSubmenu.style.display = 'none';
    nativeSubmenu.style.visibility = 'hidden';
    nativeSubmenu.style.pointerEvents = 'none';

    link.removeAttribute('aria-controls');
    link.removeAttribute('aria-haspopup');
    link.setAttribute('aria-expanded', 'false');

    item.dataset.rovynelDirectShopReady = 'true';

    item.addEventListener('pointerenter', () => openDirectPanel(item));
    item.addEventListener('focusin', () => openDirectPanel(item));
    item.addEventListener('pointerleave', (event) => {
      if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return;
      setTimeout(() => {
        if (!item.matches(':hover, :focus-within')) closeDirectPanel(item.closest('header-component'));
      }, 80);
    });
    item.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!item.matches(':hover, :focus-within')) closeDirectPanel(item.closest('header-component'));
      }, 80);
    });
  };

  const prepareAll = () => {
    document.querySelectorAll(shopLinkSelector).forEach((link) => {
      prepareShopItem(link.closest(menuItemSelector));
    });
  };

  document.addEventListener('pointerover', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const shopItem = target?.closest('[data-rovynel-direct-shop-ready]');
    if (shopItem) {
      openDirectPanel(shopItem);
      return;
    }

    const otherMenuItem = target?.closest(menuItemSelector);
    if (otherMenuItem) {
      const header = otherMenuItem.closest('header-component');
      closeDirectPanel(header);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('header-component').forEach(closeDirectPanel);
    }
  });

  prepareAll();

  new MutationObserver(prepareAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
(() => {
  const productPath = '/products/7-in-1-wifi-rs485-aquarium-water-monitor';
  const images = [
    ['https://cdn.shopify.com/s/files/1/0978/8316/0865/files/rovynel-rs485-designed-for-simplicity_545a3a71-59b8-4665-b827-33ad1e9797cd.png?v=1782194840', 'Rovynel RS485 water quality monitor with WiFi connectivity high precision sensors and smart app alerts'],
    ['https://cdn.shopify.com/s/files/1/0978/8316/0865/files/rovynel-rs485-professional-probe_4e571afb-e5ef-4c14-a2b6-d2fe9202bff5.png?v=1782194840', 'Rovynel RS485 professional water quality probe with pH ORP EC temperature and IP68 waterproof features'],
    ['https://cdn.shopify.com/s/files/1/0978/8316/0865/files/rovynel-rs485-seven-parameters-specifications_c1192c3a-ecab-44f2-babe-90e870c5f17f.png?v=1782194840', 'Rovynel RS485 detailed specifications for pH TDS EC salinity temperature specific gravity and ORP'],
    ['https://cdn.shopify.com/s/files/1/0978/8316/0865/files/rovynel-rs485-how-to-use_6196bb5d-e0d2-470c-b30b-75560a7ee1ea.png?v=1782194840', 'Rovynel RS485 water quality monitor setup guide for aquarium installation'],
    ['https://cdn.shopify.com/s/files/1/0978/8316/0865/files/rovynel-rs485-wide-range-applications_4e413d0c-87ec-4d16-a568-7bf66124356d.png?v=1782194842', 'Rovynel RS485 water quality monitor applications for saltwater tanks freshwater tanks koi ponds shrimp tanks turtle habitats and hydroponics'],
  ];

  const initRovynelRs485DetailMedia = () => {
    if (window.location.pathname !== productPath) return;
    if (document.querySelector('.rvp-detail-media')) return;

    const description = document.querySelector('.rvp-description');
    if (!description) return;

    const media = document.createElement('div');
    media.className = 'rvp-detail-media';
    media.setAttribute('aria-label', 'RS485 water quality monitor detail images');

    images.forEach(([src, alt]) => {
      const image = document.createElement('img');
      image.src = src;
      image.alt = alt;
      image.loading = 'lazy';
      media.append(image);
    });

    description.insertAdjacentElement('afterend', media);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRovynelRs485DetailMedia);
  } else {
    initRovynelRs485DetailMedia();
  }
})();